import React from 'react'
import PropTypes from 'prop-types'
import './styles'

import { Link } from 'react-router-dom'

import Datetime from '/components/datetime'

# A vertical lifecycle list. Each event carries a `level` — done, pending or
# problem — which drives the marker and the connector leading into it. The most
# recent completed event is highlighted as the current one.
export default \
class Timeline extends React.Component
  @propTypes:
    events: PropTypes.array

  @defaultProps:
    events: []

  render: ->
    return null unless @props.events?.length

    events = @props.events
    # the connector into a step is styled by that step, so each row needs to know
    # what follows it
    current = @currentIndex events

    <ol className="Timeline">
      {for event, idx in events
        next = events[idx + 1]
        classes = ['event', event.level, event.kind]
        classes.push 'current' if idx is current
        classes.push "next-#{next.level}" if next

        <li key={event.id or idx} className={classes.join ' '}>
          <span className="marker"/>
          <div className="body">
            <div className="title">{event.title}</div>
            {@meta event}
          </div>
        </li>
      }
    </ol>

  # the last thing that actually happened — outstanding steps don't count, however
  # they're levelled
  currentIndex: (events) ->
    last = -1
    for event, idx in events
      last = idx unless event.kind is 'next_step'
    last

  meta: (event) ->
    return null unless event.occurred_at or event.actor_label or event.detail

    <div className="meta">
      {if event.occurred_at
        <Datetime date={event.occurred_at} inline={true}/>
      }
      {if event.actor_label
        <span className="actor">
          {if event.actor?.slug
            <Link to={"/users/#{event.actor.slug}"}>{event.actor_label}</Link>
          else
            event.actor_label
          }
        </span>
      }
      {if event.detail
        <span className="detail">{event.detail}</span>
      }
    </div>
